import React from 'react';

/**
 * TutorialCard component displays instructional content for each tutorial step
 * 
 * @param {string} text - The instruction text to display
 * @param {number} currentStep - The current step number
 * @param {number} totalSteps - Total number of steps in the tutorial
 * @param {function} onNext - Function to call when the Next button is clicked
 * @param {function} onSkip - Function to call when the End button is clicked
 * @param {function} onPrevious - Function to call when the Previous button is clicked
 */
const TutorialCard = ({ text, currentStep, totalSteps, onNext, onSkip, onPrevious }) => {
  // Determine if this is the last step
  const isLastStep = currentStep === totalSteps;
  // Determine if this is the first step
  const isFirstStep = currentStep === 1;
  
  return (
    <div className="tutorial-card flex flex-col">
      {/* End button in top right corner */}
      <div className="absolute top-2 right-2">
        <button 
          onClick={onSkip}
          className="text-gray-500 text-sm hover:text-gray-700 transition-colors"
        >
          End
        </button>
      </div>
      
      {/* Content section */}
      <div className="flex-1">
        <p className="tutorial-text mt-4">{text}</p>
      </div>
      
      {/* Controls section - always at bottom */}
      <div className="mt-auto">
        <div className="tutorial-buttons">
          {/* Previous button - only show if not on first step */}
          {!isFirstStep && (
            <button 
              onClick={onPrevious}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
            >
              Previous
            </button>
          )}
          
          {/* Spacer if on first step */}
          {isFirstStep && <div></div>}
          
          {/* Next/Finish button */}
          <button 
            onClick={onNext}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
          >
            {isLastStep ? 'Got it!' : 'Next'}
          </button>
        </div>
        
        {/* Step indicators */}
        <div className="tutorial-steps mt-3">
          {Array.from({ length: totalSteps }).map((_, index) => (
            <div 
              key={`step-${index + 1}`}
              className={`tutorial-step ${currentStep === index + 1 ? 'tutorial-step--active' : ''}`}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TutorialCard; 